// extracted by mini-css-extract-plugin
export default {"addLinkBtn":"styles_addLinkBtn__KB3VT","addLinkBtnIcon":"styles_addLinkBtnIcon__tkLQP","input":"styles_input__3Hbs0","first":"styles_first__eFzEI"};